export default __webpack_public_path__ + "polymer.7c70b8e2.png";